<template>
    <layout>
    <span slot="header">{{ title }}<button class="btn-pop-close delete" aria-label="close" @click="closeModal"></button></span>
    <div slot="content">
      

      <div class="pop-content-search">
        <el-form size="mini">
          <el-row :gutter="24">
            <el-col :span="6">
              <el-row>
                <el-form-item label="고객구분">
                  <el-col :span="14">
                    <el-input type="text" v-model="form.custTypeNm" disabled></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :span="18">
              <el-row>
                <el-form-item label="사이트명">
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm1" disabled></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm2" disabled></el-input>
                  </el-col>
                  <el-col :span="6">
                    <el-input type="text" v-model="form.siteNm3" disabled></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </el-form>
      </div>

      <div class="grid-wrap">
        <tabs :tab="tab" :active-btn="active" @changeTab="changeTab"/>
        <component v-bind:is="viewer" :tabData="data" @onCellClicked="onCellClicked"/>
        <!--  -->
      </div>
    </div>
  </layout>
</template>

<script>
/**
 * * components
 */
import Layout from '@/components/Slot/ModalSlot.vue';

/**
 * * Tab 구분 컴포넌트
 */
import tabs from '@/components/AS/Tabs/index.vue';
import has from './HasModel';
import add from './AddModel';

import rcpt from './index';
/**
 * Url JOIN
 */
 function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
    mixins: [rcpt],
    props: {
        data: {
            Type: Array
            , required: false
        },
        custNo: {
            Type: String
            , required: false
        },
        agMaker: {Type: String , required: false},
        agMakerCd: {Type: String , required: false},
        agMakerNm: {Type: String , required: false}
    },
    components: {Layout, tabs, has, add},
    data() {
        return {
            title: '접수모델선택',
            viewer: 'has',
            active: true,
            tab:[
                {tabId: 'has', tabName:'보유모델', tabCss:"btn btn-primary", tabNo:'0'},
                {tabId: 'add', tabName:'모델추가', tabCss:"btn btn-outline-primary", tabNo:'1'},/** 'btn btn-nonActive'버튼 비활성화 class */
            ],
            form: {
              custTypeNm: '',
              siteNm1: '',
              siteNm2: '',
              siteNm3: '',
              siteId: '',
              custNo: '',
              agMaker: '',
              agMakerCd: '',
              agMakerNm: ''
            }
        }
    },
    created() {
        this.$bus.$on('input', (val) => {
            console.log('-> input bus on ', val);
        });
    },
    mounted() {
      console.log('pop this.data ====' , this.data);
      this.form = this.data[0].param;
      this.form.agMaker = this.agMaker;
      this.form.agMakerCd = this.agMakerCd;
      this.form.agMakerNm = this.agMakerNm;
      
      // if(this.form.siteId && this.form.siteId > 0 ){
      //   this.viewer = 'has' 
      //   this.tab[0].tabCss = 'btn btn-primary'
      //   this.tab[1].tabCss = 'btn btn-outline-primary'
      // } else {
        // 무조건 모델추가가 보이도록 요청
        this.viewer = 'add';
        this.tab[0].tabCss = 'btn btn-outline-primary';
        this.tab[1].tabCss = 'btn btn-primary';
      //}
      
      

      console.log('mount this.viewer: ', this.viewer, this.form.siteId);

      // this.goSiteModel();

      //pop slots modal move
      $(".animation-content").addClass('pop_min2');
      $(".animation-content").draggable({'cancel':'.modal-card-body'});
      //ModalSlot open z-index change
      $('.lnb').css('z-index', '4');
    },
    destroyed() {
        //ModalSlot open z-index change
        $('.lnb').css('z-index', '7');
    },
    methods: {
        changeTab(params) {
            this.viewer = params.tabId;
            console.log('changeTab this.viewer: ', this.viewer)
        },
        closeModal() {
            console.log(this.$parent)
            this.$parent.close();
        },
        goSiteModel(){
          // this.$store.commit('loading')
          const vform = {
                companyId: this.$store.state.loginInfo.compCd || '',
                custId: this.form.custId || '',
                custType: this.form.custType || '',
                custTypeNm: this.form.custTypeNm ? this.form.custTypeNm : '',
                boundCustNm: this.form.boundCustNm ? this.form.boundCustNm : '',
                custNm: this.form.custNm ? this.form.custNm : '',
                maker: this.form.maker ? this.form.maker : '',
                modelGroup: this.form.modelGroup ? this.form.modelGroup : '',
                standardModelNm: this.form.standardModelNm ? this.form.standardModelNm : '',
                modelCd: this.form.modelCd ? this.form.modelCd : '',
                modelNm: this.form.modelNm ? this.form.modelNm : '',
                sortType: this.form.sortType ? this.form.sortType : '',
                page: 1,
                totalpage: 9999,
                totalcount: 9999,
                curPage: 0,
                processTime: ''
            }

          this.$http.post(_url("/api/asMng/popup/siteModelSelect"), vform
                ).then(response => {
                console.log('response.data' , response.data)
                
                 
            }).finally(() => {
                this.$store.commit('finish')
          });
        },
        onCellClicked(param){
          this.$emit('close', param)
          this.closeModal()
        }
    }

}
</script>

<style lang="scss" scoped>
.modal-card {
  width: 970px;
}

.display-area {
  :global(img) {
    width: 100%;
  }
}
</style>